import React from 'react';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'LLMs in production: governance that actually ships',
      excerpt: 'Retrieval, evaluation, guardrails, and ownership—how to get automation past the pilot without surprising legal or security.',
      date: 'March 15, 2025',
      category: 'AI & automation',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=600&fit=crop',
      readTime: '6 min read'
    },
    {
      id: 2,
      title: 'Cloud 3.0: migrations without the hangover',
      excerpt: 'Landing zones, hybrid reality, FinOps, and why “lift and shift” is only the first chapter of the story.',
      date: 'March 10, 2025',
      category: 'Cloud',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop',
      readTime: '8 min read'
    },
    {
      id: 3,
      title: 'Zero trust when you are not a hyperscaler',
      excerpt: 'Identity, logging, and patching priorities for teams that need real defense—not a shelf of unused security tools.',
      date: 'March 5, 2025',
      category: 'Security',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=600&fit=crop',
      readTime: '7 min read'
    },
    {
      id: 4,
      title: 'Managed IT: what “24/7” should mean in 2026',
      excerpt: 'Alert noise vs. signal, runbooks your team can follow, and how to know when outsourced operations are earning their retainer.',
      date: 'February 28, 2025',
      category: 'Operations',
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop',
      readTime: '5 min read'
    }
  ];

  return (
    <section id="blog" className="blog-section">
      <div className="container">
        <div className="section-header-modern">
          <span className="section-label-modern">Insights</span>
          <h2 className="section-title-modern">Field notes</h2>
          <p className="section-description-modern">
            Perspectives on AI in operations, cloud and security trade-offs, and running reliable systems in 2026 and beyond.
          </p>
        </div>

        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-card-image">
                <img 
                  src={post.image} 
                  alt={post.title}
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=800&h=600&fit=crop';
                  }}
                />
                <span className="blog-category">{post.category}</span>
              </div>
              <div className="blog-card-content">
                <div className="blog-meta">
                  <span className="blog-date">{post.date}</span>
                  <span className="blog-read-time">{post.readTime}</span>
                </div>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <button type="button" className="blog-read-more">
                  Read More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="blog-cta">
          <a href="/blog" className="btn-primary">
            View All Posts
          </a>
        </div>
      </div>
    </section>
  );
};

export default Blog;

